import { Box, makeStyles } from '@material-ui/core'
import React from 'react'
import PropTypes from 'prop-types'
import DateRangePicker from '../../molecules/DateRangePicker'
import { useAppContext } from '../../../redux/slices/appContext'
import { parseCustomDateRangeRawValue } from '../../molecules/RelativeDateSelect'

const useStyles = makeStyles(() => ({
  dateRangeInput: {
    background: '#FFFFFF',
    border: '3px solid #D7DCE1',
    borderRadius: '4px',
    padding: '6px 8px',
    '& input': {
      padding: '0'
    }
  }
}))

const CustomDateRangeSelector = ({ value, onChange }) => {
  const classes = useStyles()
  const { availableDates } = useAppContext()

  const { startDate = null, endDate = null } = parseCustomDateRangeRawValue(value)

  return (
    <DateRangePicker
      onChange={onChange}
      defaultStartDate={startDate}
      defaultEndDate={endDate}
      minDate={availableDates.min}
      maxDate={availableDates.max}
      format='MM/DD/YYYY'
      shouldDisableWeekends
      datePickerWidth='12rem'
      divider={<Box mx='0.25rem' />}
      startDateLabel={null}
      endDateLabel={null}
      InputProps={{
        classes: {
          root: classes.dateRangeInput
        },
        disableUnderline: true,
        error: false
      }}
    />
  )
}

CustomDateRangeSelector.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func
}

export default CustomDateRangeSelector
